import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
  model,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BaseFormControlComponent } from '../../../shared/components/base-form-control/base-form-control.component';
import { ValidityIconComponent } from '../../../shared/components/validity-icon/validity-icon.component';
import { FormControlDirective } from '../../../shared/directives/form-control/form-control.directive';
import { NumericInputDirective } from '../../../shared/directives/numeric-input/numeric-input.directive';
@Component({
  selector: 'app-form-telephone-input',
  templateUrl: './telephone-input.component.html',
  styleUrls: ['./telephone-input.component.scss'],
  providers: [
    {
      provide: BaseFormControlComponent,
      useExisting: forwardRef(() => TelephoneInputComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormControlDirective,
    NumericInputDirective,
    ReactiveFormsModule,
    ValidityIconComponent,
  ],
  standalone: true,
})
export class TelephoneInputComponent extends BaseFormControlComponent<string> {
  autocomplete = input<string>('off');
  placeholder = model<string>('');
}
